<mat-card [class.configured]="configureSelected" [ngClass]="{large: largeChart() === 'large'}">
    <mat-card-header #header class="widget-header large">
        <mat-card-title>
            Outage Trend for <br />
            {{ chartStartDate() | momentDate }} to {{ filters().endDate | momentDate }}
        </mat-card-title>

        <!--        <div class="actions hide-on-export">-->
        <!--            <button-->
        <!--                matTooltip="Export as PNG"-->
        <!--                matTooltipPosition="above"-->
        <!--                matTooltipShowDelay="250 "-->
        <!--                mat-icon-button-->
        <!--                (click)="exportComponent()">-->
        <!--                <vulcan-icon icon="download-simple" weight="bold"></vulcan-icon>-->
        <!--            </button>-->
        <!--        </div>-->
    </mat-card-header>

    <mat-card-content>
        <eaglei-nom-chart
            [config]="chartConfigOptions"
            [states]="filters().locations"
            [startDate]="chartStartDate()"
            [endDate]="filters().endDate">
        </eaglei-nom-chart>
    </mat-card-content>
</mat-card>
